import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ThankYouBannerComponent } from '../shared/thank-you-banner/thank-you-banner.component';
import { SuccessModalHelperService } from '../_helpers/success-modal-helper/success-modal-helper.service';

@Component({
    selector: 'app-test',
    templateUrl: './test.component.html',
    styleUrls: ['./test.component.css'],
    standalone: false
})
export class TestComponent implements OnInit, AfterViewInit {
  @ViewChild(ThankYouBannerComponent, {static: true}) private thankYouBanner!: any;

  public loading = false;

  constructor(private successModalHelper: SuccessModalHelperService) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
  }

  public toggle(): void {
   this.successModalHelper.show();
  }

  public generateRandomBanner(): void {
      
    this.thankYouBanner.generateBanner();
  }
  public removeBanner(): void {
    this.thankYouBanner.removeBanner();
  }

}
